export enum UserRole {
  CES_ADMIN = 'CES Admin',
  ADMIN = 'Admin',
  EDITOR = 'Editor',
  VIEWER = 'Viewer',
}
